import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=1911fccc"
import script from "./StoreDetail.vue?vue&type=script&lang=js"
export * from "./StoreDetail.vue?vue&type=script&lang=js"
import style0 from "./StoreDetail.vue?vue&type=style&index=0&id=1911fccc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports